import { Component, OnInit } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { Router } from '@angular/router';
import _ from 'lodash';

import { NavigationEnd, NavigationStart, NavigationCancel, NavigationError } from '@angular/router';
import { AuthService } from './services/auth.service';

import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  activeRoute: string;

  showMemberHeader = false;
  showPublicHeader = false;
  showAuthHeader = false;
  showPublicFooter = false;
  showAuthFooter = false;
  showSettingsRoute = false;

  userData: any;
  isLoggedIn = false;

  isIframe = false;

  loadingBar = false;

  constructor(
    location: PlatformLocation,
    public router: Router,
    public authService: AuthService,
  ) {
    location.onPopState((e: any) => {
      window.location.href = e.target.location.href;
    });
    this.loadScript();

    this.childRouteChange();

  }

  loadScript() {
    const url = environment.paymentUrl;
    const node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  ngOnInit() {
  }

  onActivate(event) {
    const scrollToTop = window.setInterval(() => {
      const pos = window.pageYOffset;
      if (pos > 0) {
          window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
          window.clearInterval(scrollToTop);
      }
    }, 16);
  }

  childRouteChange() {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        this.loadingBar = true;
      } else if (val instanceof NavigationEnd || val instanceof NavigationCancel || val instanceof NavigationError) {
        this.loadingBar = false;
      }
      this.isLoggedIn = this.authService.isLoggedIn();
      this.userData = this.authService.getUserData();
      if (!(val instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0);
      this.activeRoute = this.router.url;
      if (_.includes(this.activeRoute, '/scenes/iframe')) {
        this.isIframe = true;
      } else if (_.includes(this.activeRoute, '/member')) {
        this.showPublicFooter = false;
        this.showMemberHeader = true;
        this.showSettingsRoute = true;
        this.showPublicHeader = false;
        this.showAuthHeader = false;
        this.showAuthFooter = false;
        this.isIframe = false;
      } else if (
        _.includes(this.activeRoute, '/login') ||
        _.includes(this.activeRoute, '/register') ||
        _.includes(this.activeRoute, '/forgot/password') ||
        _.includes(this.activeRoute, '/reset/password') ||
        _.includes(this.activeRoute, '/payment') ||
        _.includes(this.activeRoute, '/payment/plan') ||
        _.includes(this.activeRoute, '/payment/confirm') ||
        _.includes(this.activeRoute, '/subscription') ||
        _.includes(this.activeRoute, '/subscription/plan') ||
        _.includes(this.activeRoute, '/subscription/card') ||
        _.includes(this.activeRoute, '/subscription/confirm')
      ) {
        if (
          _.includes(this.activeRoute, '/payment') ||
          _.includes(this.activeRoute, '/payment/plan') ||
          _.includes(this.activeRoute, '/payment/confirm') ||
          _.includes(this.activeRoute, '/subscription') ||
          _.includes(this.activeRoute, '/subscription/plan') ||
          _.includes(this.activeRoute, '/subscription/card') ||
          _.includes(this.activeRoute, '/subscription/confirm')
        ) {
          this.showSettingsRoute = false;
        } else {
          this.showSettingsRoute = true;
        }
        this.showAuthHeader = true;
        this.showAuthFooter = true;
        this.showPublicFooter = false;
        this.showMemberHeader = false;
        this.showPublicHeader = false;
        this.isIframe = false;
      } else {
        this.showPublicFooter = true;
        this.showPublicHeader = true;
        this.showAuthFooter = false;
        this.showAuthHeader = false;
        this.showMemberHeader = false;
        this.isIframe = false;
      }
    });
  }
}
